export function pointInBoundingBox(lon, lat, bbox) {

    return (lon >= bbox[0] &&
        lon <= bbox[2] &&
        lat >= bbox[1] &&
        lat <= bbox[3]);
};